import { FunctionComponent } from 'react';
import { Box, Dialog } from '@primer/react';
import { CJRButton } from '../../basicComponents/cjrButton/cjrButton';
import { PLANS_PATH } from '../../utils/constants';
import { useNavigate } from 'react-router-dom';

export const UpgradeInfoDialog: FunctionComponent<any> = ({ setConfirm, confirm }) => {
  const navigate = useNavigate();
  return (
    <Dialog
      aria-labelledby="label"
      isOpen={confirm}
      onDismiss={() => setConfirm(false)}
      sx={{ height: 'initial !important' }}
    >
      <div
        style={{
          height: '80px',
          boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.25)',
          padding: '28px',
          display: 'flex',
          justifyContent: 'center',
          color: '#3B147A',
          textAlign: 'center',
          fontSize: '24px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: 'normal',
        }}
      >
        Upgrade
      </div>
      <Box p={4}>
        <Box p={3}>
        This feature is available on the <b>Company</b> and <b>Enterprise</b> plans.
        </Box>
        <Box p={3}>
        Visit our plans page to learn more about all available features.
        </Box>
      </Box>
      <Box display="flex" justifyContent="center" p={4}
        style={{
          boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.25)',
         }}>
        <CJRButton
          onClick={() => setConfirm(false)}
          style={{ marginRight: '5px' }}
          variant="juicyTertiary"
        >
          Cancel
        </CJRButton>
        <CJRButton
          onClick={() => navigate(PLANS_PATH)}
          style={{ marginLeft: '5px', maxWidth: '200px' }}
          variant="juicyPrimary"
        >
          See plans
        </CJRButton>
      </Box>
    </Dialog>
  );
};
